"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonAptosUtilsConfigSetup = void 0;
var CommonAptosUtilsConfig_1 = require("./CommonAptosUtilsConfig");
var CommonAptosUtilsConfigSetup = /** @class */ (function () {
    function CommonAptosUtilsConfigSetup() {
    }
    CommonAptosUtilsConfigSetup.register = function (config) {
        config.registerKey(CommonAptosUtilsConfig_1.CommonAptosUtilsConfig.defaultAptosNetwork);
    };
    return CommonAptosUtilsConfigSetup;
}());
exports.CommonAptosUtilsConfigSetup = CommonAptosUtilsConfigSetup;
//# sourceMappingURL=CommonAptosUtilsConfigSetup.js.map